<template>
  <img
    v-if="variant === 'header'"
    class="header-logo"
    src="@/assets/img/logo-service.png"
    alt=""
    width="248"
    height="102"
  />

  <ul v-else-if="variant === 'group'" class="list-unstyled thumb-group">
    <li class="thumb-circle" :key="image.image" v-for="image in images">
      <img :src="image.image" :alt="image.alt" />
    </li>
  </ul>

  <div
    v-else
    class="thumb-circle"
    :class="{
      'thumb-user': variant === 'user' && !small,
      'thumb-user-s': variant === 'user' && small,
      'thumb-round': variant === 'device',
      'thumb-device': variant === 'device',
      'thumb-teams': variant === 'teams',
      'thumb-setting': variant === 'setting',
    }"
  >
    <img
      v-if="variant === 'teams' || variant === 'setting'"
      width="30"
      height="30"
      :alt="alt"
      :src="src"
    />
    <img v-else :src="src" :alt="alt" />
  </div>
</template>

<script>
export default {
  name: "Image",
  props: {
    // variant: [ header, teams, user, device, setting, group ]
    variant: {
      type: String,
      default: "user",
    },
    small: {
      type: Boolean,
      default: false,
    },
    src: {
      type: String,
      default: "",
    },
    alt: {
      type: String,
      default: "",
    },
    images: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
